export const LOCKED_STATE = 'locked';
export const UNLOCKED_STATE = 'unlocked';
export const SELECTED_STATE = 'selected';
